<template>
  <div
    v-if="renderComponent"
    class="col-md-12 border border-primary p-3 text-center mb-3"
  >
    <div class="row text-center">
      <div class="col">
        <p class="h6 p-2">Update Kategori Massal</p>
      </div>
    </div>
    <div class="row">
      <div class="col my-1">
        <!-- <label class="sr-only" for="inlineFormInputGroupUsername">Username</label> -->
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text font-size-15">Kategori Lama</div>
          </div>
          <select
            name=""
            @change="oldCat"
            v-model="selectedOldCat"
            class="custom-select is-invalid custom-select-sm"
            id="oldCategories"
          >
            <option value="" selected disabled>Pilih Kategori lama</option>
            <option
              :value="od.value"
              v-for="(od, index) in oldCategories"
              :key="index"
            >
              {{ od.name }} ({{ od.total }})
            </option>
          </select>
          <div class="ml-5 invalid-feedback">Pilih Kategori lama</div>
        </div>
      </div>

      <p class="badge m-0 p-2">
        <i class="fa h3 text-secondary fa-arrow-alt-circle-right"></i>
      </p>
      <!-- To new category -->

      <div class="col my-1">
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text font-size-15">Kategori Baru</div>
          </div>
          <select
            @change="getCategoryVal"
            name="nonBookCategoryMassal"
            id="nonBookCategoryMassal"
            class="custom-select is-invalid custom-select-sm"
          >
            <option value="" selected disabled>Pilih Kategori</option>
            <option
              v-for="(lc, index) in listCategory"
              :key="index"
              :value="lc.id"
            >
              {{ lc.title }}
            </option>
          </select>
        </div>
      </div>

      <p id="loadingCategory1" class="mt-1 d-none small">
        <i class="fa fa-spinner fa-spin"></i>
      </p>

      <div class="col my-1">
        <div class="input-group">
          <div class="input-group-prepend">
            <!-- {{subCatLength}} -->
            <div
              v-show="showEl === false"
              class="input-group-text font-size-15"
            >
              Sub Kategori
            </div>
          </div>
          <select
            @change="getSubCategoryVal"
            name="nonBookSubCategoryMassal"
            id="nonBookSubCategoryMassal"
            class="custom-select is-invalid custom-select-sm d-none"
          >
            <option value="" selected disabled>Pilih Kategori</option>
            <option
              v-for="(lsc, index) in listSubCategory"
              :key="index"
              :value="lsc.id"
            >
              {{ lsc.title }}
            </option>
          </select>
        </div>
      </div>

      <p id="loadingCategory2" class="mt-1 d-none small">
        <i class="fa fa-spinner fa-spin"></i>
      </p>

      <div class="col my-1">
        <div class="input-group">
          <select
            name="nonBookSub2CategoryMassal"
            @change="lastCategoryBarang"
            id="nonBookSub2CategoryMassal"
            class="custom-select is-invalid custom-select-sm d-none"
          >
            <!-- <option value="" selected disabled>Pilih Kategori</option> -->
            <option
              v-for="(lsc, index) in listSub2Category"
              :key="index"
              :value="lsc.id"
            >
              {{ lsc.title }}
            </option>
          </select>
          <div class="input-group-prepend">
            <!-- <div class="input-group-text  font-size-15"> 3</div> -->
            <!-- <button class="btn btn-secondary mt-0" type="button">Button</button> -->
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-secondary" type="button" @click="resetForm">
      Reset
    </button>
    <button
      id="btnUpdate"
      :class="
        disabledEditCategoryNonBook
          ? 'btn btn-secondary rounded mb-2'
          : 'btn btn-primary rounded mb-2'
      "
      :disabled="disabledEditCategoryNonBook"
      type="button"
      @click="massalUpdateCategory"
    >
      Update Kategori <i class="fa fa-check"></i>
    </button>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
export default {
  props: {
    massalUpdateCategory: Function,
    oldCategories: Array,
    selectedOldCat: String,
    oldCat: Function,
    renderComponent: Boolean,
    resetForm: Function,
  },
  data() {
    return {
      listCategory: [],
      catValMassal: 0,
      subCatValMassal: 0,
      listSubCategory: [],
      listSub2Category: [],
      elShow: false,
      disabledEditCategoryNonBook: true,
    };
  },
  computed: {
    showEl: function() {
      return this.elShow;
    },
  },

  watch: {
    catValMassal() {
      this.getSubCategory();
    },
    subCatValMassal() {
      this.getSub2Category();
    },
  },
  updated() {
    if (this.listSub2Category.length === 0) {
      $("#nonBookSub2CategoryMassal").addClass("d-none");
    }

    if (this.listSub2Category.length === 1) {
      $("#nonBookSub2CategoryMassal").removeClass("is-invalid");
      this.disabledEditCategoryNonBook = false;
    }

    const e = $("#nonBookSubCategoryMassal").hasClass("d-none");
    this.elShow = e;
  },
  created() {
    this.getBarangCategory();
  },
  methods: {
    filterCatNonBook(listCat) {
      return listCat.id != 22 && listCat.id != 23;
    },
    filterCatBook(listCat) {
      let isTextBook = this.typeBook;
      return isTextBook == "text" ? listCat.id == 22 : listCat.id == 23;
    },
    getBarangCategory() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          let catList = data.data.data[0].submenu.menu;
          // this.listCategory = data.data.data[0].submenu.menu;
          this.listCategory = catList.filter(this.filterCatNonBook);
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catValMassal].submenu;
        });
    },
    getCategoryVal() {
      $("#nonBookSubCategoryMassal").addClass("is-invalid");
      $("#nonBookSub2CategoryMassal").addClass("d-none");
      $("#loadingCategory1").removeClass("d-none");
      $("#nonBookSubCategoryMassal").addClass("d-none");
      var index = $("#nonBookCategoryMassal").prop("selectedIndex");
      //index di + 3 dikarenakan yg di ambil hanya kategori buku teks dan buku non teks
      if (index > 3) {
        this.catValMassal = index + 2;
      } else {
        this.catValMassal = index;
      }

      this.subCatValMassal = 0;
      $("#nonBookSub2CategoryMassal").addClass("d-none");
      $("#nonBookCategoryMassal").removeClass("is-invalid");

      this.disabledEditCategoryNonBook = true;
    },
    getSubCategory() {
      this.subCatValMassal = 0;
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSubCategory =
            data.data.data[0].submenu.menu[this.catValMassal - 1].submenu;
          $("#loadingCategory1").addClass("d-none");
          $("#nonBookSubCategoryMassal").removeClass("d-none");
        });
    },
    getSubCategoryVal() {
      $("#loadingCategory2").removeClass("d-none");
      $("#nonBookSub2CategoryMassal").addClass("d-none");
      var index = $("#nonBookSubCategoryMassal").prop("selectedIndex");
      this.subCatValMassal = index;

      $("#nonBookSubCategoryMassal").removeClass("is-invalid");
      setTimeout(() => {
        this.disabledEditCategoryNonBook =
          this.listSub2Category.length === 0 ? false : true;
      }, 300);

      $("#nonBookSub2CategoryMassal").addClass("is-invalid");
    },
    getSub2Category() {
      axios
        .get(
          "https://siplah.eurekabookhouse.co.id/staging/product/category?for=seller"
        )
        .then((res) => {
          return res;
        })
        .then((data) => {
          this.listSub2Category =
            data.data.data[0].submenu.menu[this.catValMassal - 1].submenu[
              this.subCatValMassal - 1
            ].submenu;
          $("#loadingCategory2").addClass("d-none");
          $("#nonBookSub2CategoryMassal").removeClass("d-none");
        });
    },
    lastCategoryBarang() {
      $("#nonBookSub2CategoryMassal").removeClass("is-invalid");
      setTimeout(() => {
        this.disabledEditCategoryNonBook = $(
          "#nonBookSub2CategoryMassal"
        ).hasClass("is-invalid");
      }, 220);
    },
  },
};
</script>

<style scoped>
.border-primary {
  border-color: #2a304250 !important;
  box-shadow: 0 7px 30px -10px rgba(196, 200, 202, 0.5);
}
</style>
